import React, { PureComponent } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { buttonsV2 as Buttons } from '@breezeway/brzw-components';
import BasicConfirmModal from './basic_confirm_modal';

import './confirm_modal.scss';

const { BUTTON_THEMES } = Buttons.constants;

class ConfirmModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      shouldOpenModal: props.shouldOpenModal,
    };

    this.onClickToggleButton = this.onClickToggleButton.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.onToggle = this.onToggle.bind(this);
  }

  onClickToggleButton(evt) {
    const { skipConfirm, onConfirm } = this.props;
    _.invoke(evt, 'preventDefault');
    _.invoke(evt, 'stopPropagation');

    if (skipConfirm) {
      onConfirm();
    } else {
      this.onToggle();
    }
  }

  onToggle() {
    this.setState(prevState => ({
      shouldOpenModal: !prevState.shouldOpenModal,
    }));
  }

  onConfirm() {
    const { onConfirm } = this.props;
    this.onToggle();
    onConfirm();
  }

  render() {
    const {
      body,
      cancelButtonText,
      children,
      className,
      confirmButtonText,
      confirmButtonTheme,
      containerClassName,
      disabled,
      modalClassName,
      onConfirm,
      showCancelButton,
      title,
      wrapClassName,
    } = this.props;
    const { shouldOpenModal } = this.state;

    return (
      <div className={classnames('confirm-modal-v2', containerClassName)}>
        <div
          className="confirm-modal-v2__button"
          onClick={!disabled ? this.onClickToggleButton : null}
          role="button"
          tabIndex={-1}
        >
          {children}
        </div>
        {shouldOpenModal && (
          <BasicConfirmModal
            body={body}
            cancelButtonText={cancelButtonText}
            className={className}
            confirmButtonText={confirmButtonText}
            confirmButtonTheme={confirmButtonTheme}
            modalClassName={modalClassName}
            onConfirm={onConfirm}
            onToggle={this.onToggle}
            showCancelButton={showCancelButton}
            title={title}
            wrapClassName={wrapClassName}
          />
        )}
      </div>
    );
  }
}

ConfirmModal.propTypes = {
  body: PropTypes.node,
  cancelButtonText: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  confirmButtonText: PropTypes.string,
  confirmButtonTheme: PropTypes.oneOf(_.values(BUTTON_THEMES)),
  containerClassName: PropTypes.string,
  disabled: PropTypes.bool,
  modalClassName: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  shouldOpenModal: PropTypes.bool,
  showCancelButton: PropTypes.bool,
  skipConfirm: PropTypes.bool,
  title: PropTypes.string.isRequired,
  wrapClassName: PropTypes.string,
};

ConfirmModal.defaultProps = {
  disabled: false,
  skipConfirm: false,
};

export default ConfirmModal;
